"use client";
import type { ReactElement } from "react";
import { getFontFamily } from "@/theme/typography";
import { CSEGMENTED_PANEL_TONE_COLOR } from "./csegmentedpanel.constants";
import {
  CsegmentedpanelTone,
  type CsegmentedpanelItemData,
  type CsegmentedpanelPresentation,
} from "./csegmentedpanel.types";

const FONT_FAMILY = getFontFamily();

interface CsegmentedpanelItemProps {
  readonly item: CsegmentedpanelItemData;
  readonly presentation: CsegmentedpanelPresentation;
}

export function CsegmentedpanelItem({
  item,
  presentation,
}: CsegmentedpanelItemProps): ReactElement {
  const tone = item.tone ?? CsegmentedpanelTone.Neutral;
  const toneColor = CSEGMENTED_PANEL_TONE_COLOR[tone];

  return (
    <div
      style={presentation.cell}
    >
      {presentation.hasToneRail && (
        <span
          aria-hidden
          style={{
            position: "absolute",
            top: 0,
            insetInline: 10,
            height: 2,
            borderRadius: "0 0 2px 2px",
            backgroundColor: toneColor,
            opacity: 0.78,
          }}
        />
      )}
      <span
        style={{
          minWidth: 0,
          overflowWrap: "anywhere",
          whiteSpace: "normal",
          fontFamily: FONT_FAMILY,
          fontSize: 8.5,
          fontWeight: 700,
          letterSpacing: "0.14em",
          textTransform: "uppercase",
          lineHeight: 1.15,
          ...presentation.label,
        }}
      >
        {item.label}
      </span>
      <span
        style={{
          minWidth: 0,
          overflowWrap: "anywhere",
          whiteSpace: "normal",
          fontFamily: FONT_FAMILY,
          fontSize: 12.5,
          fontWeight: 600,
          fontVariantNumeric: "tabular-nums",
          fontFeatureSettings: '"tnum" 1',
          color: toneColor,
          ...presentation.value,
        }}
      >
        {item.value}
      </span>
    </div>
  );
}
